const ascendingAlphabetical = (array, prop) => {
  return [...array].sort((a, b) => {
    return a[prop].toLocaleLowerCase() < b[prop].toLocaleLowerCase() ? 1 : -1;
  });
};

const descendingAlphabetical = (array, prop) => {
  return [...array].sort((a, b) =>
    a[prop].toLocaleLowerCase() > b[prop].toLocaleLowerCase() ? 1 : -1
  );
};

export const alphabetize = <TItem>(
  array: TItem[],
  prop: keyof TItem,
  direction: 'asc' | 'desc' = 'desc'
) => {
  if (!array || !array.length) {
    return [];
  }

  return direction === 'desc'
    ? descendingAlphabetical(array, prop)
    : ascendingAlphabetical(array, prop);
};

export const alphabetizeStrings = (arr: string[]) => {
  return arr.sort((a, b) => {
    const nameA = a.trim().toLowerCase();
    const nameB = b.trim().toLowerCase();
    if (nameA < nameB) return -1;
    if (nameA > nameB) return 1;
    return 0;
  });
};

export const sort = <TItem>(
  list: TItem[],
  key: keyof TItem,
  formatter: (...args: any) => any
) => {
  return formatter(list, key);
};
